import { AUTH_LOGIN, AUTH_CHANGE, DATA_CHANGE } from './types';
import { func, types } from 'utils';


export const changeAuth = (key: string, data: any) => {
    func.setStorageJson(key, data);
    if(key === 'user') {
        data = func.mapUser(data);
    }
    return {
        type: AUTH_CHANGE,
        payload: { key, data },
    };
}

export const setAuthenticated = (data: { user: types.User; token: string }) => {
    func.setStorage('token', data.token);
    func.setStorageJson('user', data.user);
    data.user = func.mapUser(data.user);
    return {
        type: AUTH_LOGIN,
        payload: { ...data, isLoggedIn: data.user.id && data.token ? true : false },
    };
}

export const changeData = (key: string, data: any) => {
    func.setStorageJson(key, data);
    return {
        type: DATA_CHANGE,
        payload: { key, data },
    };
}